module.exports = __webpack_public_path__ + "img/SketchPnga8b871c5bd16ec2783b3e2d8f8a9b404def659648458943de6a7f6c07128a561.1d2eb5c9.png";